import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { MaterialService } from '../../services/material.service';
import { LearnerService } from '../../services/learner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatDialog, MatSidenav } from '@angular/material';
import { EditMaterialModalComponent } from './edit-material-modal/edit-material-modal.component';
import { FilterService } from "../../services/filter.service";
import { CourseUnitsService } from '../../services/course-units.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { Location } from '@angular/common';
import { metrialStatusArray } from '../../_models/staticArray';
import { AddUnitModalComponent } from '../units/add-unit-modal/add-unit-modal.component';
import { AddMaterialModalComponent } from './add-material-modal/add-material-modal.component';
import { UserRoleService } from '../../services/user-role.service';
import { TimeSheetService } from 'src/app/services/time-sheet.service';




@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss']
})
export class MaterialsComponent implements OnInit {
  closeBtnNeeded = true;
  file: any;
  materialIndex: any;
  groupedMaterials: any;
  courseIdForUnits: any;
  currentUser: any;
  hideActions: boolean = false;
  hideTitle: boolean = false;
  selectedUnit: any;
  showAltList = false;
  afterFilter: any;
  noDataMsg = {
    title: "No Materials!",
    data: "You have not yet added any materials"
  }
  filterActive: Boolean = false;
  user: any;
  unitNo: any;
  selectedJobData: any;
  isClient: boolean = false;
  userRole: any;
  isUser: boolean = false;

  clearCheckBox() {
    console.log("CHILD METHOD");
    this.selectedCheckbox = false;
    this.selectedMaterials.forEach((single) => {
      delete single.checked
    })

  }
  // @Input('courseid') courseId: any;
  @Input('data') data: any;
  @Input('jobId') jobId;
  @Input('materials') materialsFromJob;
  @Input('learnersAllotedFromJob') learnersAlloted = false;
  @Input('learnersFromJob') learnersFromJob;
  @Input('allLearnersFromJob') allLearners;
  @Input('course') course;
  @Input('learnersFromComponent') learnersFromComponent;
  @Input('singleJob') singleJobData
  @Input('quizStatus') learnerQuiz
  @Output() getMaterialsFromComponent: EventEmitter<any> = new EventEmitter<any>();
  @Output() showBtn: EventEmitter<any> = new EventEmitter<any>();
  @Output() assignmentAdded = new EventEmitter<any>();
  @Output() assignmentAllocated: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() allUnits: EventEmitter<any> = new EventEmitter<any>();
  materials: any = [];
  length;
  pageSizeOptions: number[] = [25, 50, 100];
  // course;
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  files;
  selectedMaterial: any;
  selectedMaterials = [];
  courseId;
  displayAllocate: Boolean = true;
  allMaterials: Observable<any>;
  displayedColumns: string[] = ['checkBox', 'Materials'];
  copyMaterials;
  selectedCheckbox: Boolean;
  view: Boolean = false;
  loading: Boolean = false;
  panelOpenState: boolean = false;
  selectedCopy;
  typeArray = ['Assignment', 'Reading'];
  noMaterial: boolean = false;
  isLevel2: boolean = false;
  unitId
  courseUnitId: any
  unitList = []
  unitTitle: any
  defaultUnit: boolean = false
  singleUnitDetails = []
  assignmentStatus = metrialStatusArray
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  systemDate
  isDisplay: boolean = false
  // [
  //   { id: '0', display: 'Assignment', status: 'Assignment', checked: true },
  //   { id: '1', display: 'Reading', status: 'Reading', checked: true },
  // ];

  learnerStatusOfQuiz = []

  // getMaterialsFromComponent;
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @Input('deletedFile') deletedFile: any;

  constructor(
    public _learnerSerice: LearnerService,
    public _courseService: CourseService,
    private location: Location,
    public _materialService: MaterialService,
    public dialog: MatDialog,
    public _filter: FilterService,
    public _snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public unitService: CourseUnitsService,
    public _change: ChangeDetectorRef,
    public _userRoleService: UserRoleService,
    public _timeSheetService: TimeSheetService
  ) {
    this.materials = [];
    // this.allMaterials = this.materials[];
    // this.activatedRoute.paramMap.subscribe(() => {
    //   if (window && window.history && window.history.state && window.history.state.role) {
    //     this.userRole = window.history.state.role
    //     console.log("userRole in materials , ", this.userRole);
    //   }
    // })
    this.dataSource = new MatTableDataSource(this.materials);
    this._timeSheetService.newDateObservable().subscribe((date) => {
      console.log("material date observable ", date);
      this.systemDate = date
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of material data", changes);

    console.log("data =======> In materials portion", this.data);
    console.log("jobId =======> In materials portion", this.jobId);
    console.log("materials =======> In materials portion", this.materials);
    console.log("materials =======> In course portion", this.course);
    console.log("*****Changes in app materials", changes);
    if (this.jobId != undefined && changes.jobId) {
      this.jobId = changes.jobId.currentValue;
      // this.getGroupedMaterials(this.data)
      // this.courseUnitId = this.data
      // this.getUnits()
      console.log("this.learners", this.jobId);
    }
    if (changes.data && changes.data.currentValue) {
      this.courseIdForUnits = changes.data.currentValue
      this.getUnits()
      this.defaultUnit = true
    }
    if (changes.materialsFromJob && changes.materialsFromJob.currentValue) {
      // this.materials = this.materialsFromJob
      // this.copyMaterials = this.materialsFromJob;
      // this.loading = false
      // if (this.materials[0] && this.materials[0]._id) {
      //   console.log('this.materials=====>', this.materials)
      //   this.updateData(this.materials)
      // }
    }
    if (changes.allLearners && changes.allLearners.currentValue) {
      this.allLearners = changes.allLearners.currentValue
    }
    if (changes.course && changes.course.currentValue) {
      console.log("IN CHANGES>COURSE>CURRENTVALUE", changes.course.currentValue);
      this.course = changes.course.currentValue
    }

    if (this.course && this.course.type == 'Level2') {
      console.log('Level2 here=================================================');
    }


    if (changes.learnersAlloted && changes.learnersAlloted.currentValue) {
      // this.selectedCheckbox = null
      // this.selectedMaterials = []
      this.selectedMaterials.forEach((single) => {
        delete single.checked
      })
      this._change.detectChanges()
    }


    if (changes.singleJobData && changes.singleJobData.currentValue) {
      this.selectedJobData = changes.singleJobData.currentValue
      console.log("this.selectedJobData.............", this.selectedJobData);
      if (!this.isUser)
        this.userRole = this.getUserRole();
      if (this.userRole == 'admin' || this.userRole == 'trainer') this.isDisplay = true
      else this.isDisplay = false
    }

    if (changes.learnerQuiz && changes.learnerQuiz.currentValue) {
      this.learnerStatusOfQuiz = changes.learnerQuiz.currentValue
    }


  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.singleJobData.instructors, 'job');
    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return 'admin'
    else if (getRole.isLearner) return 'learner'
    else if (getRole.isClient) return 'client'
    else if (getRole.isTrainer) return 'trainer'
    else if (getRole.isIQA) return 'IQA'
  }
  ngAfterViewInit() {
    console.log("AfterViewInit this.courseId = ", this.courseId);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("DATASOURCE", this.dataSource)
    console.log('materialsDiaplay', this.materials);
  }

  applyFilter(filterValue: string) {
    this.afterFilter = null

    this.filterActive = true;

    console.log('filterValue===>', filterValue, this.selectedCopy);
    if (this.selectedCopy) {
      if (filterValue) {
        let temp = this._filter.filter(filterValue, this.selectedCopy, ['title', 'type']);
        if (temp.length > 0) {
          this.updateData(temp)
        }
        else {
          this.updateData(temp)
          this.afterFilter = {
            title: "No Materials!",
            data: "Sorry, no materials matched your search"
          }
          // this.afterFilter = "No files with matched criteria found!"
        }
        console.log("this.copyMaterials", temp)

      } else {
        this.filterActive = false;
        this.updateData(this.selectedCopy)
      }
    } else {
      console.log("call this else part");

      if (filterValue && this.copyMaterials && this.copyMaterials.length) {
        let temp = this._filter.filter(filterValue, this.copyMaterials, ['title', 'type']);
        if (temp.length > 0) {
          this.updateData(temp)
        }
        else {
          this.updateData(temp)
          // this.afterFilter = "No files with matched criteria found!"
          this.afterFilter = {
            title: "No Files!",
            data: "Sorry, no files available"
          }
        }
        console.log("this.copyMaterials", temp)

      } else {
        this.filterActive = false;
        this.updateData(this.copyMaterials)
      }
    }


    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // console.log("this.dataSource.paginator", this.dataSource.paginator)

    // console.log("THIS.MATERIALS IS", this.materials);
    // if (this.selectedCopy) {
    //   this.materials = this._filter.filter(filterValue, this.selectedCopy, ['title', 'type']);
    //   if (this.materials.length > 0) {
    //     this.updateData(this.materials)
    //   }
    //   else {
    //     this.updateData(this.materials)
    //     this.afterFilter = "No files with matched criteria found!"
    //   }
    //   // this.updateData(this.materials)

    //   this.dataSource.paginator = this.paginator;
    //   if (this.dataSource.paginator) {
    //     this.dataSource.paginator.firstPage();
    //   }
    // }
    // else {
    //   // this.copyMaterials
    //   console.log("in else", this.selectedUnit)
    //   let temp = this._filter.filter(filterValue, this.selectedUnit.materials, ['title', 'type']);
    //   if (temp.length > 0) {
    //     this.updateData(temp)
    //   }
    //   else {
    //     this.updateData(temp)
    //     this.afterFilter = "No files with matched criteria found!"
    //   }
    //   console.log("this.copyMaterials", temp)
    // }
    // this.dataSource = this._filter.filter(filterValue, this.materials, ['title','type']);

  }
  ngOnInit() {
    console.log("data =======> In materials portion", this.data);
    console.log("jobId =======> In materials portion", this.jobId);
    console.log("materials =======> In materials portion", this.materials);
    this.loading = true;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    // if (this.user.isClient || this.user.isIQA) {

    //   this.displayedColumns = ['Materials'];
    //   this.hideActions = true
    // }
    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam.userRole) {
        console.log("param ?????? ", qparam);
        this.userRole = qparam.userRole
        this.isUser = true
        if (this.userRole == 0) this.isDisplay = true
        else this.isDisplay = false

      }
    })
    console.log("this.activatedRoute", this.activatedRoute.params)
    this.activatedRoute.params.subscribe(params => {
      console.log("what is paarams value", params);

      if (params['courseId'] != undefined && params['unitId'] != undefined) {
        this.courseIdForUnits = params['courseId']
        this.unitId = params['unitId']
        // this.course
        if (this.courseIdForUnits && this.unitId) {
          console.log("this is call for single unit");
          this.getCourseData()

          this.getMaterialUnitWise()
          this.getUnits()
        }
        if (this.courseIdForUnits && !this.unitId) {
          console.log("this is call for all units");

          this.getUnits()
          this.defaultUnit = true
        }
        // this.getMaterials(params['courseId']);
        // this.getGroupedMaterials(params['courseId'])
      }
    });

    if (this.router.url.includes('/material')) {
      this.view = true;
      console.log("VIEW VALUE IS", this.view)
    }
    if (this.router.url.includes('/jobs') || this.router.url.includes('/client')) {
      this.hideTitle = true;
      this.showAltList = true;
    }
    this.courseId = this.data;
    if (this.data) {
      console.log("this.data found at =====>>>>>", this.data);
      this.courseIdForUnits = this.data
    }
    // this.courseIdForUnits
    // console.log("Initialized Materials with course = ", this.courseId, { data: this.data });
    if (this.courseId) {
      console.log("CourseId  ", this.courseId);
      console.log('this.materialsFromJob===>', this.materialsFromJob);
      // this.materials = this.materialsFromJob
      // this.updateData(this.materials)
      // this.getMaterials(this.courseId);
    }
    // const paginatorIntl = this.paginator._intl;
    // paginatorIntl.nextPageLabel = '';
    // paginatorIntl.previousPageLabel = '';
  }
  onMaterialSelection(event) {
    console.log("event", event);
    console.log("this.selectedMaterials", this.selectedMaterials);
    console.log("what is the check box value===========", this.selectedCheckbox);

    if (event.checked == true) {
      event.source.value['checked'] = true
      this.selectedMaterials.push(event.source.value)
    }
    if (event.checked == false) {
      let index = _.findIndex(this.selectedMaterials, function (o) { return o._id == event.source.value._id })
      console.log("index", index);
      if (index > -1) {
        this.selectedMaterials.splice(index, 1)
      }
      // if (this.selectedCheckbox == false) {
      // console.log("call this or not");
      this.selectedCheckbox = undefined
      // }
      // this.selectedMaterials.forEach((material) => {
      //   console.log('MATERIAL', material)
      //   if (material._id == event.source.value._id) {
      //     this.selectedMaterials.splice(material, 1)
      //   }
      // })
    }
    console.log("MATERIALS ARRAY IS", this.selectedMaterials)
    this.getMaterialsFromComponent.emit({ materials: this.selectedMaterials, unitNo: this.unitNo })
    console.log("event emited")
  }

  // UTILITY

  updateData(updateData) {
    console.log("UPDATING DATA Called = ", updateData);
    console.log("");

    // this.getMaterialsFromComponent.emit({ materials: this.selectedMaterials })
    this.dataSource = new MatTableDataSource(updateData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'assignmentNo': return item.assignmentNo;
        // case 'client.name': return item.client.name;
        // case 'location.title': return item.location.title;
        // case 'course.title': return item.course.title;
        default:
          break;
      }
    };
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;
  }


  selectedStatus(event, index, status) {
    console.log("event", event, "index", index, "status", status);
    if (event == true) {
      this.typeArray.push(status);
    }
    else if (event == false) {
      const index = this.typeArray.indexOf(status);
      if (index > -1) {
        this.typeArray.splice(index, 1);
      }
    }
    this.filterUsingStatus(this.typeArray);
  }


  filterUsingStatus(assignment) {
    this.afterFilter = null
    console.log("filterUsingStatus(assignment)", assignment, "!assignment.length", !assignment.length, "assignment.length", assignment.length);
    if (!assignment.length) {
      console.log("in if", this.copyMaterials);
      // this.dataSource = new MatTableDataSource(this.selectedUnit.materials);
      this.updateData(this.copyMaterials)
    } else {
      console.log("In else", this.copyMaterials);
      if (this.copyMaterials && this.copyMaterials.length) {

        const finalarray = [];
        this.copyMaterials.forEach((e1) => assignment.forEach((e2) => {
          console.log("in forEach e1", e1, "e2", e2);
          if (e1.type == e2) {
            console.log("e1.type == e2", e1.type, e2);
            finalarray.push(e1)
          }
        }));
        console.log('Selected Copy::::', finalarray);
        this.selectedCopy = finalarray;
        if (finalarray && !finalarray.length) {
          // this.afterFilter = "No files with matched criteria found!"
          this.afterFilter = {
            title: "No Files!",
            data: "Sorry, no files available"
          }

          this.filterActive = true;
        }
        console.log("value of selected copy", this.selectedCopy);

        this.updateData(this.selectedCopy);
      }
    }
  }
  deleteFile(event) {
    console.log("IN delete function", event);
    console.log("this.materials[this.materialIndex].files", this.materials[this.materialIndex].files);

    let index = _.findIndex(this.materials[this.materialIndex].files, function (o) {
      console.log("o._id", o, "event.fileId", event.fileId);
      return o == event.fileId.toString();
    })
    if (index > -1) this.materials[this.materialIndex].files.splice(index, 1)
    console.log("this.materials[this.materialIndex].files", this.materials[this.materialIndex].files);
    console.log(" dataSource ", this.dataSource)
    // this.dataSource = [];
    // this.dataSource = new MatTableDataSource([]);
    console.log(" dataSource ", this.dataSource)

    console.log("this.materials", this.materials)
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.materials)));
    console.log(" dataSource ", this.dataSource)
    this.mydsidenav.close()
    // this.dataSource = this.materials;

  }

  changedUnit(event) {
    console.log("when change the unit", event);
    this.unitId = event.value
    let temp = _.findIndex(this.unitList, function (o) { return o._id == event.value })
    if (temp > -1) {
      this.unitNo = this.unitList[temp].unitNo
    }

    console.log('temp', this.unitNo)
    this.materials.unitDate
    // this.courseIdForUnits = this.courseIdForUnits
    // console.log("what is the value of this", this.defaultUnit);

    this.getMaterialUnitWise()
    if (!this.defaultUnit) {
      this.location.replaceState('/material/' + this.courseIdForUnits + '/' + this.unitId);
    }


    // this.router.navigate(['/material/', this.courseUnitId, this.unitId])
  }




  // MODALS

  addUnitModal() {
    let data = {
      isEdit: false,
      courseId: this.courseIdForUnits
    }
    this.openDialog(AddUnitModalComponent, data).subscribe(res => {
      console.log("add unit response", res)
      if (res == undefined) return
      else {
        this.unitList.push(res)
        // this.unitsCopy.push(res)
        this.openSnackBar("Unit Added successfully", "OK")
      }
    })
  }



  addMaterialModal() {

    let obj = {};

    // console.log('this.course._id=======>>', this.course._id);
    console.log("selected unit details", this.singleUnitDetails);

    if (this.course && this.course._id) {
      console.log("first if call");
      obj['unitList'] = this.unitList
      obj['courseFolder'] = this.courseUnitId
      obj['course'] = this.course._id
      obj['unitNo'] = this.singleUnitDetails[0].unitNo
      if (this.course && this.course.type && this.course.type == 'Level2') {
        obj['courseType'] = 'Level2'
      } else {
        obj['courseType'] = 'Level3'
      }
    }
    else {
      console.log("else part call");
      obj['unitList'] = this.unitList
      obj['courseFolder'] = this.courseUnitId
      obj['course'] = this.courseIdForUnits
      obj['unitNo'] = this.singleUnitDetails[0].unitNo
      if (this.course && this.course.type && this.course.type == 'Level2') {
        obj['courseType'] = 'Level2'
      } else {
        obj['courseType'] = 'Level3'
      }
    }



    var addedMaterial = this.openDialog(AddMaterialModalComponent, obj)
      .subscribe((materials) => {
        console.log("response of add new material", materials);
        console.log("displaay gorup of maaterisal==========", this.unitId);

        if (materials == undefined) return;


        if (this.courseUnitId == materials.courseFolder) {
          this.materials.push(materials)
          this.updateData(this.materials)
          this.noMaterial = false
        }

        this.openSnackBar("Material added successfully!", "Ok");
        console.log("final array to display", this.materials);





      }, err => {
        return this.openSnackBar("Material could not be added!", "Ok");
      });

  }


  editMaterialModal(data) {
    this.openDialog(EditMaterialModalComponent, data).subscribe((material) => {
      console.log("DIALOG CLOSED", material)
      // Handle Error
      if (material.result == "err") return this.openSnackBar("Material could not be edited!", "Ok");

      // EDIT HANDLE
      if (material.action == 'edit') {
        console.log("HANDLING EDIT SUCCESS", material.data);
        data = material.data;
        let Index = this.materials.findIndex(function (i) {
          return i._id === data._id;
        })
        if (Index > -1) {
          if (this.materials[Index].unitNo == material.data.material.unitNo) {
            this.materials[Index] = material.data;
          }
          else {
            let index = _.findIndex(this.groupedMaterials, function (o) {
              console.log("o._id", o._id, "materials.unitNo", material.data.unitNo);
              return o._id == material.data.unitNo
            })
            if (index > -1) {
              this.groupedMaterials[index].materials.push(material.data)
            }
            else {
              let data = {
                _id: material.data.unitNo,
                type: material.data.type,
                materials: [material.data]
              }
              this.groupedMaterials.push(data)
              this.materials.push(material.data)
            }
          }
        }
        this.handleSnackBar({ msg: "Material edited successfully!", button: "Ok" });
      }
      // DELETE HANDLE
      else if (material.action == 'delete') {
        console.log("Deleted ", material);
        this.handleSnackBar({ msg: "Material deleted successfully!", button: "Ok" });
      }
      this.updateData(this.materials);

    });
  }
  editFromTile(event) {
    console.group(" ******** editFromTile ********", event)


    if (this.courseUnitId == event.courseFolder) {
      let element = this.materials.find(x => x._id === event._id);
      console.log("single element data", element);

      event['courseUnit'] = this.singleUnitDetails

      let index = this.materials.findIndex(x => x._id === event._id);
      this.materials[index] = event
      this.updateData(this.materials)
    } else {
      let index = this.materials.findIndex(x => x._id === event._id);
      this.materials.splice(index, 1)
      if (this.materials && this.materials.length) {
        this.updateData(this.materials)
      } else {
        this.noMaterial = true
      }
    }



    // let editMaterialIndex = _.findIndex(this.selectedUnit.materials, function (o) {
    //   console.log("o._id", o._id, "event._id", event._id);
    //   return o._id == event._id
    // })

    // event.courseUnit.title = event.courseUnit.unitTitle

    // if (editMaterialIndex > -1) {
    //   let courseUnit = event.courseUnit

    //   for (let i = 0; i < this.selectedUnit.materials.length; i++) {
    //     if (i !== editMaterialIndex) {
    //       console.log("editFromTile FOR LOOP Called ")
    //       this.selectedUnit.materials[i]['courseUnit'] = courseUnit
    //       console.log(" this.selectedUnit.materials['courseUnit'] ", this.selectedUnit.materials[i]['courseUnit'])
    //     }
    //   }


    //   console.log(" editFromTile editMaterialIndex ", editMaterialIndex)
    //   console.log(" editFromTile event ", event)
    //   console.log(" editFromTile this.selectedUnit.materials ", this.selectedUnit.materials)
    // }



    // if ((this.selectedUnit._id == event.unitNo) && editMaterialIndex > -1) {
    //   console.log(" IN IF ")
    //   console.log("this.selectedUnit._id == event.unitNo && index > -1")
    //   this.selectedUnit.materials[editMaterialIndex] = event
    //   this.copyMaterials = this.selectedUnit.materials;
    //   this.filterUsingStatus(this.typeArray);
    //   // this.updateData(this.selectedUnit.materials)
    //   // }
    // }
    // else {
    //   console.log(" IN ELSE ")
    //   let index = _.findIndex(this.groupedMaterials, function (o) {
    //     console.log("o._id", o._id, "event.unitNo", event.unitNo);
    //     return o._id == event.unitNo
    //   })
    //   if (index > -1) {
    //     this.groupedMaterials[index].materials.push(event)
    //     this.selectedUnit.materials.splice(editMaterialIndex, 1)
    //     this.copyMaterials = this.selectedUnit.materials;
    //     this.filterUsingStatus(this.typeArray);
    //     // this.updateData(this.selectedUnit.materials)
    //   }
    //   else {
    //     let data = {
    //       _id: event.unitNo,
    //       type: event.type,
    //       materials: [event]
    //     }
    //     this.groupedMaterials.push(data)
    //     this.materials.push(event)
    //     if (index > -1) {
    //       this.selectedUnit.materials.splice(editMaterialIndex, 1)
    //       this.copyMaterials = this.selectedUnit.materials;
    //       this.filterUsingStatus(this.typeArray);
    //       // this.updateData(this.selectedUnit.materials)
    //     }
    //   }
    // }
    console.groupEnd()
  }

  deletedMaterial(event) {
    console.log("Material Deleted Event : ", event);
    this.materials.splice(this.materials.findIndex(function (i) {
      return i._id === event._id;
    }), 1);
    // this.selectedUnit.materials.splice(this.selectedUnit.materials.findIndex(function(i){
    //   console.log("i._id",i._id,"=== event._id", event._id)
    //   return i._id === event._id;
    // }))
    // let index = _.findIndex(this.selectedUnit.materials, function (o) { return o._id == event._id })
    // if (index > -1) {
    //   this.selectedUnit.materials.splice(index, 1)
    // }
    console.log("material deleted", this.materials);
    this.updateData(this.materials)
    this.openSnackBar("Material deleted successfully!", 'OK')
  }

  loadMaterialFiles(event) {
    console.log("loadMaterialFiles Called with event = ", event)
    this.selectedMaterial = event.materialId;
    console.log("Setting selectedMaterial = ", event.materialId)
    this.files = event.files;
  }
  fileDetailsComp(event) {
    console.log("fileDetailsComp", event);
    this.openFilesSideNav.emit({ event })
    // this.materialIndex = event.materialIndex
    // this.file = event.file;
    // this.mydsidenav.open();
    // console.log("EVENT OPENING", event.file);
  }
  allocatedFromTile(event) {
    console.log("In material", event);
    this.assignmentAllocated.emit({ msg: "assignment allocated from material tile" })
  }

  unitChanged(material) {
    console.log("unit clicked", material);
    this.closeFilesSideNav.emit("close")
    this.selectedUnit = material
    this.copyMaterials = material.materials
    this.filterUsingStatus(this.typeArray);

  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // API CALLS

  getMaterials(courseId) {
    this.loading = true
    console.log("getting materials in materials component for courseId = ", courseId)
    this._courseService.getCourse(courseId).subscribe((courses: any) => {
      console.log('GETTING Details o course--------------', courses);

      this.course = courses.pop();
      this.materials = this.course.materials;
      console.log("value of course material============ ", this.materials);

      console.log('This material:::', this.materials, this.course);
      this.loading = false;
      // if(this.course && this.course.type == 'Level2'){
      // this.location.replaceState(
      //   this.router.createUrlTree(
      //     [this.locationStrategy.path().split('?')[0]], // Get uri
      //     {
      //       relativeTo: this.activatedRoute, queryParams: {
      //         courseId: this.job.course._id, currentTab: event.index
      //       }
      //     }
      //   ).toString()
      // );
      // }
      // this.dataSource = new MatTableDataSource(this.materials);
      // this.copyMaterials = this.materials;
      // this.updateData(this.materials)
    });
  }

  getMaterialUnitWise() {
    this.singleUnitDetails = []
    let obj = {
      unitId: this.unitId,
      courseId: this.courseIdForUnits
    }
    this.unitService.getUnitsMaterial(obj).subscribe((response) => {
      console.log("response of all material===========", response);
      this.materials = response.material
      if (this.materials && this.materials.length) {
        this.copyMaterials = this.materials
        this.noMaterial = false;
        this.updateData(this.materials)
      } else {
        this.noMaterial = true;
      }
      this.loading = false
      this.singleUnitDetails.push(response.unitData)
      this.courseUnitId = response.unitData._id
      this.unitTitle = response.unitData.title
    }, error => {
      console.log("error while get material", error);
      this.loading = false
    })
  }


  getUnits() {
    console.log("what is the course id", this.courseIdForUnits);
    console.log("what is the value of dedfault vaar=======", this.defaultUnit);
    this.loading = true
    this.unitService.getUnits(this.courseIdForUnits).subscribe(res => {
      this.unitList = res;
      // this.unitsCopy = res;
      console.log("units list by course id", this.unitList)


      if ((this.defaultUnit && this.defaultUnit == true) && (this.unitList && this.unitList.length)) {
        this.courseUnitId = this.unitList[0]._id
        this.unitId = this.unitList[0]._id
        this.unitNo = this.unitList[0].unitNo
        this.getMaterialUnitWise()
      } else {
        // this.noMaterial = true
        // this.loading = false
      }
      this.allUnits.emit(this.unitList)
      this.loading = false
    })
  }



  getCourseData() {
    this.loading = true
    this._courseService.getCourse(this.courseIdForUnits).subscribe(res => {
      console.log("COURSE IN UNITS", res)

      this.course = res[0]
      // this.courseTitle = this.course.title
      // this.loading = false
    })
  }


  getGroupedMaterials(courseId) {
    console.log("getting materials in materials component for courseId = ", courseId)
    this._courseService.getCourseGrouped(courseId).subscribe((groupedmaterial: any) => {

      console.log('Response From Services====>', groupedmaterial);
      console.log('Material Found', this.noMaterial);

      if (groupedmaterial.material.length > 0) {
        this.noMaterial = false;
        console.log('Material Found', this.noMaterial);
      } else {
        this.noMaterial = true;
        console.log('Material Found', this.noMaterial);
      }

      this.groupedMaterials = groupedmaterial.material
      console.log("display gorup material ========", this.groupedMaterials);

      this.selectedUnit = groupedmaterial.material[0]

      if (this.selectedUnit && this.selectedUnit.materials) {
        this.copyMaterials = this.selectedUnit.materials
        console.log("IN IF ANYWAY!!!!")
        this.updateData(this.selectedUnit.materials)
      }
      this.loading = false;
      console.log('groupedmaterial ', this.groupedMaterials, "this.selectedUnit", this.selectedUnit, "this.copyMaterials", this.copyMaterials);
    });
  }




}
